import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Label } from 'semantic-ui-react';

import { bem } from '../../core/design/bem';
import { GroupMissingField } from '../types';

const css = bem('GroupIncompleteLabel');

type GroupIncompleteLabelProps = {
  /** Éléments manquants sur le groupe (créneau, programme, invités) */
  missingFields: GroupMissingField[];
};

/** Badge "À compléter", avec le détail des éléments manquants en infobulle */
const GroupIncompleteLabel = ({ missingFields }: GroupIncompleteLabelProps): JSX.Element | null => {
  const { t } = useTranslation();
  if (!missingFields.length) return null;

  const missing = missingFields
    .map((field) => t(`group-visits.incomplete.missing.${field}`))
    .join(', ');

  return (
    <Label
      size="small"
      color="orange"
      className={css().toString()}
      title={t('group-visits.incomplete.tooltip', { missing })}
    >
      <Icon name="exclamation triangle" />
      {t('group-visits.incomplete.label')}
    </Label>
  );
};

export default GroupIncompleteLabel;
